export enum SortingOrder {
  ASC = 'ASC',
  DESC = 'DESC',
}
